import React, { FC, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Home from '../../pages/Home/Home'
import { useAppDispatch } from '../../store/hooks'
import { fetchByCompanyInfo } from '../../store/slices/infoSlice'
import Projects from '../../pages/Projects/Projects'
import Articles from '../../pages/Articles/Articles'
import AboutUs from '../../pages/AboutUs/AboutUs'
import Products from '../../pages/Products/Products'
import DetailProduct from '../../pages/DetailProduct/DetailProduct'
import DetailProject from '../../pages/DetailProject/DetailProject'
import Contacts from '../../pages/Contacts/Contacts'
import PrivacyPolicy from '../../pages/PrivacyPolicy/PrivacyPolicy'
import NotFound from '../../pages/NotFound/NotFound'

const Main: FC = () => {
    const location = useLocation();
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(fetchByCompanyInfo())
    }, [dispatch])

    return (
        <main>
            <Routes key={location.pathname} location={location}>
                <Route index element={<Home />} />
                <Route path='/projects' element={<Projects />} />
                <Route path='/projects/:id/:name' element={<DetailProject />} />
                <Route path='/about-us' element={<AboutUs />} />
                <Route path='/articles' element={<Articles />} />
                <Route path='/products' element={<Products />} />
                <Route path='/products/:id/:name' element={<DetailProduct />} />
                <Route path='/contacts' element={<Contacts />} />
                <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                <Route path='*' element={<NotFound />} />
            </Routes>

        </main>
    )
}

export default Main